// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"466c407f","732":"7523bf53","977":"69a0f062"}[chunkId] + ".chunk.js";
};